<template>
    <div>
        <div class="light-color-bg position-relative justify-full-height">
        <HeaderMain title="Organisation" :modalActivator="true" @activateModal="(e)=>modalActive=true"></HeaderMain>
        <div class="container-70">
            <selection-box :values="values" v-model="result" @update:modelValue="saveAndContinue('formType', result.value, result.url)"></selection-box>          
        </div>
        <div></div>
        <div class="container-70">
            <div class="come-back mt-50px" @click="$router.back()">
                <CustomIcon name="chevron-left"></CustomIcon>Question précédente
            </div>
        </div>
  
    </div>
    <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <div v-for="(value, index) in values " :key="index" class="d-flex vertical-center">
                <div class="col-15 no-shrink">
                    <img :src="value.img" class="modal-img"/>
                </div>
                <p class="modal-text ml-20px">{{ value.description }}</p>
            </div>  
    </ModalInfo>
    </div>
</template>
<script>
import HeaderMain from '../../components/HeaderMain.vue'
import SelectionBox from '../../components/SelectionBox.vue'
import CustomIcon from '../../components/CustomIcon.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            modalActive:false,
            values: [
                {
                    img: require('@/assets/images/calcul_simple.png'),
                    label: 'Calcul simplifié',
                    value: "simple",
                    url:"/questionnaire/organisation/simple/question-1",
                    description:"Le calcul simplifié (3 questions) utilise des informations partielles basées sur des moyennes. Le résultat global pourrait être surestimé.",
                },
                {
                    img: require('@/assets/images/calcul_detaillee.png'),
                    label: 'Calcul détaillé',
                    value: "detaillee",
                    url: "/questionnaire/organisation/detaille/question-1",
                    description:"Le calcul détaillé (5 questions) nécessite plus de données, ce qui le rend plus précis.",
                }
            ]
        }
    },
    mixins:[utils],
    components: {
        HeaderMain,
        SelectionBox,
        CustomIcon,
        ModalInfo
    }
}
</script>